export default "__VITE_ASSET__BQzQp7r8__"